<template>

  <div class="top-menu">
    <el-menu  mode="horizontal" text-color="#333">

      <template v-for="(item, index) in items">
        <el-menu-item
            :index="index + ''"
            @click.native="openHome(item)"
            :key="index"
        >
          <template slot="title">
            <i :class="item.source" style="padding-right: 5px"></i>
            <span>{{item.name }}</span>
          </template>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>


export default {
  components: {

  },
  name: "topMenu",
  data() {
    return {
      itemHome: {
        name: "首页",
        source: "el-icon-menu",
      },
      activeIndex: "1",
      items: [
        {
          name: "首页",
          source: "el-icon-menu",
        },
        {
          name: "帮助",
          source: "",
        },
        {
          name: "下载",
          source: "",
        },
      ],
    };
  },
  inject: ["index"],
  created() {

  },
  computed: {

  },
  methods: {
  },
};
</script>
<style scoped>

</style>
